export default {
  title: {
    id: 'review_ai_summary_title',
    defaultMessage: 'What customers are saying',
  },
  showMore: {
    id: 'review_ai_summary_show_more',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'review_ai_summary_show_less',
    defaultMessage: 'Show less',
  },
} as const
